/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { UniswapV3Swap, UniswapV3SwapInterface } from "../UniswapV3Swap";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_router",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "PoolNotSet",
    type: "error",
  },
  {
    inputs: [],
    name: "RouterIsZero",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "path",
        type: "address[]",
      },
      {
        internalType: "uint24[]",
        name: "fees",
        type: "uint24[]",
      },
    ],
    name: "pathToBytes",
    outputs: [
      {
        internalType: "bytes",
        name: "bytesPath",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_priceProvider",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "resolveFee",
    outputs: [
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "router",
    outputs: [
      {
        internalType: "contract ISwapRouter",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "spenderToApprove",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_priceProvider",
        type: "address",
      },
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
    ],
    name: "swapAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountOut",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_priceProvider",
        type: "address",
      },
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
    ],
    name: "swapAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type UniswapV3SwapConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UniswapV3SwapConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UniswapV3Swap__factory extends ContractFactory {
  constructor(...args: UniswapV3SwapConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "UniswapV3Swap";
  }

  deploy(
    _router: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<UniswapV3Swap> {
    return super.deploy(_router, overrides || {}) as Promise<UniswapV3Swap>;
  }
  getDeployTransaction(
    _router: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_router, overrides || {});
  }
  attach(address: string): UniswapV3Swap {
    return super.attach(address) as UniswapV3Swap;
  }
  connect(signer: Signer): UniswapV3Swap__factory {
    return super.connect(signer) as UniswapV3Swap__factory;
  }
  static readonly contractName: "UniswapV3Swap";
  public readonly contractName: "UniswapV3Swap";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UniswapV3SwapInterface {
    return new utils.Interface(_abi) as UniswapV3SwapInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniswapV3Swap {
    return new Contract(address, _abi, signerOrProvider) as UniswapV3Swap;
  }
}
